import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { MyScore } from 'src/models/myscores.model';


@Component({
  selector: 'history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  public busy: boolean;
  public scores: MyScore[] = [];
  public faCaretDown = faCaretDown;
  public faCaretUp = faCaretUp;
  public sortData: { field: string, order: number } = { field: 'lastName', order: 1 }
  public userId: string;

  constructor(private http: HttpClient, private authorizeService: AuthorizeService,
    private router: Router, private aRoute: ActivatedRoute) {
    this.aRoute.queryParams.subscribe(params => {
      this.userId = params.userId;
    });
  }

  public wins: number = 0;
  public losses: number = 0;
  public ngOnInit() {
    this.busy = true;
    const url = !!this.userId ? `/admin/PlayerHistory?userId=${this.userId}` : '/api/playerapi/history';

    this.http.get<MyScore[]>(url).subscribe(
      (resp) => {
        console.log(resp);
        this.busy = false;
        this.scores = resp.map(r => new MyScore(r));
        // .length = 0;
        // for (let s of resp) {
        //   this.scores.push(new MyScore(s));
        // }
        this.sort();
        this.wins = this.scores.reduce((acc, elm) => (elm.points == 3 || elm.points == 4) ? acc + 1 : acc, 0);
        this.losses = this.scores.length - this.wins;
      },
      (err) => alert(err)
    )

    this.busy = false;
  }

  public isTournament(l) {
    return l.includes("Tourney");
  }

  public changeSort($event, field, order) {
    $event.preventDefault();
    this.sortData.field = field;
    this.sortData.order = order;
    this.sort();
  }
  private sort() {
    this.scores.sort((a, b) => a[this.sortData.field] > b[this.sortData.field] ? this.sortData.order : -this.sortData.order)
  }
}
